import TrackingIncidencesService from 'js/services/api/tracking/incidences.js'

const ACTIVATED = 'activated';
const PLANNED_INCIDENCE = 'planned';

export default {
  data() {
    return {
      incidencesPerRoute: {}
    }
  },

  methods: {
    /*
     * Obtains incidents for the indicated routes
     */
    getAllRouteIncidences(routes = []) {
      const routeIds = routes.map(route => route.id)

      const params = {
        template: 'app_web',
        route_ids: routeIds,
        municipality_id: this.$municipality.id,
        page: 1,
        per: 0
      }

      TrackingIncidencesService.index({params, skipLoading: true}).then(response => {
        let incidences = response.data.filter(
          incidence => incidence.broadcast_description_app_web !== '' &&
                       incidence.last_state == ACTIVATED
        )

        /** Check the type of incident and then the validity if it corresponds to planned */

        incidences = incidences.filter( incidence => {
          if (incidence.type == PLANNED_INCIDENCE) {
            const ElapsedTime = Date.now();
            const now = new Date(ElapsedTime)
            const start = new Date(incidence.planned_start_date)
            const end = new Date(incidence.planned_end_date)

            if (now.getDate() >= start.getDate() && now.getDate() <= end.getDate()) {
              return incidence
            }
          } else {
            return incidence
          }
        })

        incidences = incidences.map(incidence => ({
          id: incidence.id,
          date: incidence.date,
          affected_routes: incidence.affected_routes,
          route_ids: incidence.route_ids,
          broadcast_description_app_web: incidence.broadcast_description_app_web,
          type: incidence.type,
          planned_start_date: incidence.planned_start_date,
          planned_end_date: incidence.planned_end_date,
          position: {
            lat: incidence.lat,
            lng: incidence.lng
          }
        }))

        routeIds.forEach(routeId => {
          const filteredIncidences = incidences.filter(
            incidence => _.includes(incidence.route_ids, routeId)
          )
          const routeIndex = _.findIndex(routes, searchedRoute => searchedRoute.id === routeId)
          this.$set(this.incidencesPerRoute, routeId, filteredIncidences)
          this.$set(
            routes,
            routeIndex,
            _.merge(routes[routeIndex], {incidences: filteredIncidences.length})
          )
        })
      })
    },

    onIncidenceAdd(marker, incidence) {
      this.$set(incidence, 'marker', marker)
    },

    /*
     * Open the incident information
     */
    onIncidenceClick(element) {
      const currentIncidence = element.target.options.icon.options.incidence

      const popupTemplate = require('./incidence-popup.pug');

      const selectedRoute = this.routesToShow[0]

      const routeName = `${selectedRoute.subline_name} - ${selectedRoute.destination}`

      let otherAffectedRoutes = currentIncidence.affected_routes.filter(
        route => route.name !== routeName && route.active === 1
      )

      otherAffectedRoutes = _.map(otherAffectedRoutes, route => ({
        color: route.subline_primary_color,
        destination: route.destination,
        extension: route.subline_extension,
        subline_name: route.subline_name
      }))

      const dateToShow = currentIncidence.type == PLANNED_INCIDENCE ?
                          `${moment(currentIncidence.planned_end_date).format('DD/MM/YYYY HH:mm')}h` :
                          `${moment(currentIncidence.date).format('DD/MM/YYYY HH:mm')}h`

      // If there is no previous popup associated
      // with the stop we create a new one
      if (!element.target.popup) {
        const popupData = {
          incidenceDate: dateToShow,
          incidenceDescription: currentIncidence.broadcast_description_app_web,
          affectedRoutesTitle: this.$t('map.affected_routes'),
          otherAffectedRoutes,
          hasManyRoutes: otherAffectedRoutes.length > 5
        }

        const popup = L.popup({
          closeButton: false
        }).setContent(popupTemplate(popupData))

        element.target.unbindPopup()
        element.target.bindPopup(popup).openPopup()
      } else {
        // If there is already a popup we simply open it again
        element.target.popup.openPopup()
      }
    },

    /*
     * Returns the icon for each incident
     */
    incidenceIcon(incidence) {
      const icon = require('assets/images/map/incidence.png');
      const IncidenceIcon = L.Icon.extend({
        options: {
          incidence,
          iconUrl: icon,
          iconAnchor: [18, 18],
          popupAnchor: [0, -18],
          className: 'leaflet-incidence'
        }
      })

      return new IncidenceIcon({incidence})
    }
  }
}
